import store from "@/store";

// WayForPay subscription page from the client's brief; the payment is matched to the psychologist by email/phone
export const SUBSCRIPTION_PAY_URL = "https://secure.wayforpay.com/sub/Platforma.life";

// cabinet pages an unpaid psychologist cannot open: only the main page with the payment stays available
const LOCKED_PATHS = ["/dashboard/settings", "/dashboard/specialization", "/dashboard/schedule", "/dashboard/blog", "/dashboard/forum", "/dashboard/chat"];

// approved psychologist whose placement is not paid (the API says so only while payment is enforced)
export function isSubscriptionLocked(user = store.getters["user/getUser"]) {
  return (
    store.getters["user/getAuthParam"].userRole === "psychologist" &&
    !!user &&
    user.active === true &&
    user.subscription_active === false
  );
}

export function isLockedPath(path) {
  return LOCKED_PATHS.includes(path.toLowerCase().replace(/\/+$/, ""));
}
